import type { UserFacingMetricsDto } from '@signalvote/shared';
import { apiJson } from './apiFetch';
import { campaignHeaders, defineQuery } from '../../lib/data';

export type { UserFacingMetricsDto };

export const useFinanceMetrics = defineQuery({
  key: () => ['finance', 'metrics'],
  reads: 'GET /api/finance/metrics',
  staleTime: 30_000,
  fetch: (_: undefined, { campaignId }): Promise<UserFacingMetricsDto> =>
    apiJson<UserFacingMetricsDto>('/api/finance/metrics', {
      headers: campaignHeaders(campaignId),
      error: 'Failed to fetch finance metrics',
    }),
});
